export default __webpack_public_path__ + "locales/ja-JP/PeopleTranslations.json?hash=c09e8b000e97edbfd6e5ded4ec2eb8fc";